import { render, staticRenderFns } from "./LatestArticles.vue?vue&type=template&id=53c82ee2&"
import script from "./LatestArticles.vue?vue&type=script&lang=js&"
export * from "./LatestArticles.vue?vue&type=script&lang=js&"
import style0 from "./LatestArticles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LatestArticles.vue"
export default component.exports